"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvitationService = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class InvitationService {
    /**
     * @param code
     * @returns Invitation Ok
     * @throws ApiError
     */
    static getInvitation(code) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/v1/invitations/{code}',
            path: {
                'code': code,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }
    /**
     * @param code
     * @param requestBody
     * @returns any Ok
     * @throws ApiError
     */
    static acceptInvitation(code, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'PUT',
            url: '/v1/invitations/{code}/accept',
            path: {
                'code': code,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Unauthorized`,
            },
        });
    }
}
exports.InvitationService = InvitationService;
